module.exports = __webpack_public_path__ + "static/media/sales-and-purchase.4564337d.png";